import {getMethod} from '~/api'

async function get(id) {
    return await getMethod(`/api/companies/${id}/settings/generatekey`)
}

export {get}
